import CardActionArea from '@mui/material/CardActionArea';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import ArrowRightIcon from '@mui/icons-material/ArrowForward';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import LazyLoad from 'react-lazyload';
import ProgressiveImage from 'react-progressive-image';
import { slugFromCC } from 'tf-post-parser';
import shadow from '../../helpers/shadow';
import BlurHashCanvas from '../General/BlurHashCanvas';
import LinkWrapper from './LinkWrapper';
import imageCrop from 'helpers/imageCrop';

const placeholder = (
  <Skeleton variant="rectangular" width="100%" height={350} />
);

export default function CarouselCountryItem({ post, isLastItem }) {
  const imgSrc = imageCrop(post.image, 1000, 700);

  const useStyles = makeStyles()(() => ({
    img: {
      width: '100%',
      transition: 'all 0.5s',
      height: '350px',
      backgroundImage: `linear-gradient(rgba(0, 0, 0, ${
        isLastItem ? 0.5 : 0.1
      }),rgba(0, 0, 0,${isLastItem ? 0.8 : 0.3})), url("${imgSrc}")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    imgContainer: {
      borderRadius: 8,
      height: '350px',
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: shadow.md,
    },
    heading: {
      textShadow: '1px 1px 20px #343A40',
      fontSize: 35,
    },
    arrowFont: {
      fontSize: 80,
    },
  }));

  const { classes } = useStyles();

  const locationLink = `/destinations/${slugFromCC(post.countryCode)}${
    post.subdivision ? `/${post.subdivision}` : ''
  }${post.city ? `/${post.city}` : ''}`;

  return (
    <div className="w-100">
      <LinkWrapper linkHref={isLastItem ? '/destinations' : locationLink}>
        <div
          key={post.permlink}
          className="w-100"
          style={{ maxHeight: '350px' }}
        >
          <div className={classes.imgContainer}>
            <CardActionArea aria-label={isLastItem ? 'View more' : post.title}>
              <LazyLoad
                offset={100}
                height={250}
                once
                placeholder={placeholder}
              >
                <BlurHashCanvas hash={post.blurHash} width={600} height={250}>
                  <ProgressiveImage src={imgSrc} placeholder={placeholder}>
                    {(src, loading) => {
                      if (loading) {
                        return placeholder;
                      }
                      return (
                        <div className={classes.img}>
                          <div className="row h-100 w-100 m-0 text-center">
                            <div className="my-auto text-center w-100">
                              <Typography
                                variant="h5"
                                className={`${classes.heading} text-light font-weight-bold`}
                              >
                                {isLastItem ? 'View more' : post.title}
                              </Typography>
                              {isLastItem && (
                                <div
                                  className={`text-light text-center ${classes.arrowFont}`}
                                >
                                  <ArrowRightIcon fontSize="inherit" />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    }}
                  </ProgressiveImage>
                </BlurHashCanvas>
              </LazyLoad>
            </CardActionArea>
          </div>
        </div>
      </LinkWrapper>
    </div>
  );
}
